(function($, Drupal, once) {
  'use strict';

  const key = '11706392818913188';
  const license = 'us-autocomplete-pro-cloud';

  Drupal.behaviors.certSenderAddressStep = {
    attach: function(context, settings) {
      const elements = $(once('address-step', '.form-wrapper[data-webform-key]', context));
      elements.each(function() {
        let $formStepWrapper = $(this);

        if ($formStepWrapper.data('webform-key') !== 'address_step') {
          return;
        }

        let $nextPageBtn;

        let addressStep = {
          sections: {
            $needCOI: null,
            $confirmAddress: null,
            $fixEditAddress: null
          },
          $addressLookupConfirmBtn: null,
          $customUnitNum: null,
          $autoCompleteInput: null,
          $confirmAddressBtns: null,
          $fixEditBtns: null,
          address: {
            $primary: null,
            $secondary: null,
            $city: null,
            $state: null,
            $zipcode: null
          },
          userInputAddress: {
            $primary: null,
            $secondary: null,
            $city: null,
            $state: null,
            $zipcode: null
          }
        };

        init();

        let selected = null;

        function init() {
          addressStep.$autoCompleteInput = $formStepWrapper.find('.address-autocomplete');

          addressStep.sections.$needCOI = $formStepWrapper.find('.section--need-coi');
          addressStep.sections.$confirmAddress = $formStepWrapper.find('.section--confirm-address');
          addressStep.sections.$fixEditAddress = $formStepWrapper.find('.section--fix-edit-address');

          addressStep.$addressLookupConfirmBtn = $formStepWrapper.find('.btn.address-lookup-confirm-btn');

          addressStep.$addressLookupConfirmBtn.attr('disabled', false);
          addressStep.$customUnitNum = $formStepWrapper.find('.form-item-unit-number .form-control');
          addressStep.$confirmAddressBtns = $formStepWrapper.find('.confirm-address-buttons input.button');
          addressStep.$fixEditBtns = $formStepWrapper.find('.fix-edit-buttons input.button');

          addressStep.address.$primary = $formStepWrapper.find('.certsender-address .form-item-address-address .form-control');
          addressStep.address.$secondary = $formStepWrapper.find('.certsender-address .form-item-address-address-2 .form-control');
          addressStep.address.$city = $formStepWrapper.find('.certsender-address .form-item-address-city .form-control');
          addressStep.address.$state = $formStepWrapper.find('.certsender-address select');
          addressStep.address.$zipcode = $formStepWrapper.find('.certsender-address .form-item-address-postal-code .form-control');

          addressStep.userInputAddress.$primary = $formStepWrapper.find('.certsender-user-input-address .form-item-user-input-address-address .form-control');
          addressStep.userInputAddress.$secondary = $formStepWrapper.find('.certsender-user-input-address .form-item-user-input-address-address-2 .form-control');
          addressStep.userInputAddress.$city = $formStepWrapper.find('.certsender-user-input-address .form-item-user-input-address-city .form-control');
          addressStep.userInputAddress.$state = $formStepWrapper.find('.certsender-user-input-address select');
          addressStep.userInputAddress.$zipcode = $formStepWrapper.find('.certsender-user-input-address .form-item-user-input-address-postal-code .form-control');

          $nextPageBtn = $(context).find('.form-actions .webform-button--next');

          let hasError = false;

          const addressKeys = Object.keys(addressStep.userInputAddress);

          for (let i = 0; i < addressKeys.length; i++) {
            const $field = addressStep.userInputAddress[addressKeys[i]];
            if ($field.hasClass('error')) {
              hasError = true;
              addressStep.sections.$needCOI.hide();
              addressStep.sections.$confirmAddress.hide();
              addressStep.sections.$fixEditAddress.show();
              break;
            }
          }

          if (!hasError) {
            for (let i = 0; i < addressKeys.length; i++) {
              const $field = addressStep.userInputAddress[addressKeys[i]];
              if ($field.val() !== '') {
                confirmAddressStep();
                break;
              }
            }
          }


          addressStep.$addressLookupConfirmBtn.on('click', function(event) {
            event.preventDefault();

            if (addressStep.$customUnitNum.val() && !addressStep.address.$secondary.val()) {
              addressStep.address.$secondary.val(addressStep.$customUnitNum.val());
            }

            confirmAddressStep();
          });

          addressStep.$confirmAddressBtns.on('click', function(event) {
            event.preventDefault();
            const $thisBtn = $(this);

            if ($thisBtn.hasClass('yes-confirm-address')) {
              $nextPageBtn.trigger('click');
            }
            else if ($thisBtn.hasClass('no-fix-address')) {
              addressStep.sections.$confirmAddress.hide();
              addressStep.sections.$fixEditAddress.show();
            }
          });

          addressStep.$fixEditBtns.on('click', function(event) {
            event.preventDefault();

            const $thisBtn = $(this);

            if ($thisBtn.hasClass('confirm-fix')) {
              let addressData = getAddressDataFromInputs(addressStep.userInputAddress);
              populateAddressFields(addressData, addressStep.address);
              $nextPageBtn.trigger('click');
            }
            else if ($thisBtn.hasClass('cancel-fix')) {
              let addressData = getAddressDataFromInputs(addressStep.address);
              populateAddressFields(addressData, addressStep.userInputAddress);
              addressStep.sections.$fixEditAddress.hide();
              addressStep.sections.$confirmAddress.show();
            }
          });
        }

        const autoSelectOptions = {
          lookup: async function(query, done) {

            let options = {
              key: key,
              license: license,
              search: query,
              selected: ''
            };

            if ((selected !== null) && (selected.inputValue.trim() === query.trim())) {
              options.search = selected.inputValue;
              options.selected = selected.query;
            }
            else {
              selected = null;
            }

            let results = await addressLookup(options);
            done(results);
          },
          minChars: 2,
          deferRequestBy: 200,
          preserveInput: true,
          onSelect: async function(suggestion) {
            if (suggestion.hasUnits) {
              selected = buildSelectedQuery(suggestion);
              addressStep.$autoCompleteInput.val(selected.inputValue);
              addressStep.$autoCompleteInput.trigger('focus');
            }
            else {
              addressStep.$autoCompleteInput.val(suggestion.value);
              populateAddressFields(suggestion.data, addressStep.address);

              // Set unit num field val to val of hidden unit num field:
              if (!addressStep.$customUnitNum.val() && addressStep.address.$secondary.val()) {
                addressStep.$customUnitNum.val(addressStep.address.$secondary.val());
              }

              addressStep.$addressLookupConfirmBtn.attr('disabled', false);
            }
          }
        }

        let autocomplete = addressStep.$autoCompleteInput.devbridgeAutocomplete(autoSelectOptions);

        function confirmAddressStep() {
          let addressData = getAddressDataFromInputs(addressStep.address);
          if (addressData.street_line !== '') {
            populateAddressFields(addressData, addressStep.userInputAddress);

            let confirmTextEl = buildAddressConfirmText(addressData);
            addressStep.sections.$confirmAddress.find('.confirm-address-text').html(confirmTextEl);
            addressStep.sections.$needCOI.hide();
            addressStep.sections.$confirmAddress.show();
          } else {
            buildAddressConfirmText(addressData);
            // JH 2024-09-25 Define variables, grab all manual inputs for address
            let addressString, unitNumber, manualStreetField, manualCityField, manualStateField, manualZipField, manualUnitField, splitAddressData;
            addressString = document.getElementById('edit-address-lookup').value;
            unitNumber = document.getElementById('edit-unit-number').value;
            manualStreetField = document.getElementById('edit-user-input-address-address');
            manualCityField = document.getElementById('edit-user-input-address-city');
            manualStateField = document.getElementById('edit-user-input-address-state-province');
            manualZipField = document.getElementById('edit-user-input-address-postal-code');
            manualUnitField = document.getElementById('edit-user-input-address-address-2');
             // Use a regular expression to capture street, city, state, and zipcode
            const regex = /^(.+?),\s*([A-Za-z\s]+?),\s*([A-Z]{2})\s*(\d{5})$/;
            const match = addressString.match(regex);
            if (match) {
              manualStreetField.value = match[1];
              manualCityField.value = match[2];
              manualStateField.value = match[3];
              manualZipField.value = match[4];
            }
            manualUnitField.value = unitNumber;
            addressStep.sections.$needCOI.hide();
            addressStep.sections.$fixEditAddress.show();
          }
        }
      });
    }
  };

  function getAddressDataFromInputs(addressFields) {
    let addressData = {
      street_line: addressFields.$primary.val(),
      secondary:  addressFields.$secondary.val(),
      city: addressFields.$city.val(),
      state:  addressFields.$state.val(),
      zipcode:  addressFields.$zipcode.val()
    };

    return addressData;
  }

  function buildAddressConfirmText(addressData) {
    let addressText1 = addressData.street_line;
    let addressText2 = addressData.city + ', ' + addressData.state + ' ' + addressData.zipcode;

    if (addressData.secondary) {
      addressText1 += ' ' + addressData.secondary;
    }

      let addressConfirmDiv = document.createElement('div');
      addressConfirmDiv.classList.add('confirm-address-text-confirmation-box');
      if (addressData.street_line !== '') {
        let lineBreak = document.createElement('br');
        let addressText1Node = document.createTextNode(addressText1);
        let addressText2Node = document.createTextNode(addressText2);
        addressConfirmDiv.appendChild(addressText1Node);
        addressConfirmDiv.appendChild(lineBreak);
        addressConfirmDiv.appendChild(addressText2Node);
      } else {
        let addressTextEmpty = document.createTextNode('Address will need to entered manually.');
        addressConfirmDiv.appendChild(addressTextEmpty);
      }
    return addressConfirmDiv;
  }

  /**
   *
   * @param {*} $addressWrapper
   */
  function populateAddressFields(addressData, addressFields) {
    addressFields.$primary.val(addressData.street_line);
    addressFields.$secondary.val(addressData.secondary);
    addressFields.$city.val(addressData.city);
    addressFields.$state.val(addressData.state);
    addressFields.$zipcode.val(addressData.zipcode);
  }

  async function addressLookup(options) {
    const results = await $.ajax({
      url: 'https://us-autocomplete-pro.api.smartystreets.com/lookup',
      data: options
    });

    let processedSuggestions = {
      suggestions: []
    };

    if (results.suggestions !== null) {
      for (let i = 0; i < results.suggestions.length; i++) {
        let processedSuggestion = buildAddressSuggestion(results.suggestions[i]);
        processedSuggestions.suggestions.push(processedSuggestion);
      }
    }

    return processedSuggestions;
  }

  /**
   * Process the suggestion result.
   * @param {*} suggestion
   */
  function buildAddressSuggestion(suggestion) {
    let suggestionObj = {
      // The suggestion text
      value: '',
      // The unprocessed address object
      data: suggestion,
      // Boolean for whether an additional query needs to run for specific units
      hasUnits: (parseInt(suggestion.entries) > 1)
    }

    let suggestionString = '';
    suggestionString += suggestion.street_line;

    if (suggestionObj.secondary !== '') {
      suggestionString += ' ' + suggestion.secondary;
    }

    if (suggestionObj.hasUnits) {
      suggestionString += ' (' + suggestion.entries + ' more entries)';
    }

    suggestionString += ' ' + suggestion.city;
    suggestionString += ', ' + suggestion.state;
    suggestionString += ' ' + suggestion.zipcode;
    suggestionObj.value = suggestionString;

    return suggestionObj;
  }

  function buildSelectedQuery(selectedSuggestion) {
    let selected = {
      query: '',
      inputValue: ''
    };

    selected.query += selectedSuggestion.data.street_line;
    selected.query += ' ' + selectedSuggestion.data.secondary;

    // Input value will be set to just the street_line + secondary.
    selected.inputValue = selected.query;

    selected.query += ' (' + selectedSuggestion.data.entries + ')';
    selected.query += ' ' + selectedSuggestion.data.city;
    selected.query += ' ' + selectedSuggestion.data.state;
    selected.query += ', ' + selectedSuggestion.data.zipcode;

    return selected;
  }
})(jQuery, Drupal, once);
